import { useEffect, useState } from 'react'

function useStickyState<T>(key: string, defaultValue: T, onSettled?: (value: T) => void): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    const stickyValue = localStorage.getItem(key)

    if (!stickyValue)
      return defaultValue

    try {
      return JSON.parse(stickyValue)[key] as T
    } catch {
      return defaultValue
    }
  })

  useEffect(() => {
    if (value === null) {
      localStorage.removeItem(key)
    } else {
      localStorage.setItem(key, JSON.stringify({ [key]: value }))
    }

    onSettled?.(value)
  }, [key, value, onSettled])

  return [value, setValue]
}

export default useStickyState
